export var actionKey = '@@NETWORKBAR';
export var watchedGroupsStreamId = 'NETWORKBAR_WATCHED_GROUPS';
export var recommendedGroupsStreamId = 'NETWORKBAR_RECOMMENDED_GROUPS';
//# sourceMappingURL=constants.js.map